import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Injector,
  OnDestroy,
} from '@angular/core';
import { Subject, takeUntil, tap } from 'rxjs';
import { DropdownService } from 'src/app/project/components/dropdown/dropdown-service/dropdown.service';
import { setSecondaryDropdown } from 'src/app/project/components/dropdown/secondary-dropdown';
import { ActiveService } from 'src/app/project/services/active/active.service';
import { checkCustomWorkspaceId } from '../../workspace/workspace';
import { EWorkspaces } from '../../workspace/workspaces.enum';
import { ESavedView } from '../models/saved-view.enum';
import { TSavedViews } from '../models/saved-views.model';
import { SavedViewsButtonComponent } from '../saved-views-button/saved-views-button.component';
import { SavedViewsService } from '../saved-views.service';

@Component({
  selector: 'pp-saved-views-dropdown',
  templateUrl: './saved-views-dropdown.component.html',
  styleUrls: ['./saved-views-dropdown.component.scss'],
  providers: [DropdownService],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SavedViewsDropdownComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  injectedDropdownService: DropdownService;
  dropdownVisible: boolean;
  selectedOption: ESavedView = ESavedView.PERSONAL;
  savedViews: TSavedViews;
  workspaceId: string;
  ESavedView = ESavedView;
  EWorkspaces = EWorkspaces;

  savedViewsButtonComponent: SavedViewsButtonComponent;

  constructor(
    private injector: Injector,
    private savedViewsService: SavedViewsService,
    private activeService: ActiveService,
    private cdr: ChangeDetectorRef,
  ) {
    // TODO Move to other component to be used thoughout the app
    // Separate instance of a dropdown service to allow 2 dropdowns to be opened at the same time
    this.injectedDropdownService = this.injector.get(DropdownService);
    setSecondaryDropdown(this.injectedDropdownService);
    this.workspaceId = checkCustomWorkspaceId() || this.activeService.getActiveWorkspaceId();

    this.savedViews = this.savedViewsService.getSavedViews(this.workspaceId);
    this.setSelectedViewId();

    this.savedViewsService.viewsChange$
      .pipe(
        takeUntil(this.destroy$),
        tap((views) => {
          this.savedViews = views[this.workspaceId];
          this.cdr.markForCheck();
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  setSelectedViewId(): void {
    const selectedViewId = this.savedViewsService.getSelectedViewId(this.workspaceId);
    selectedViewId
      ? this.setActiveSwitch(selectedViewId)
      : (this.selectedOption = ESavedView.PERSONAL);
  }

  setActiveSwitch(viewId: string): void {
    if (this.workspaceId === EWorkspaces.OVERVIEW) {
      this.selectedOption = ESavedView.PERSONAL;
      return;
    }

    const personalViews = this.savedViews.personal.views;
    personalViews.find((view) => view.id === viewId)
      ? (this.selectedOption = ESavedView.PERSONAL)
      : (this.selectedOption = ESavedView.SHARED);
  }
}
